import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, take } from 'rxjs';
import { ZenSnackbarService } from 'src/app/shared/Theme/services/zen-snackbar.service';
import { ChildrenAnimation, fadeUpDown } from 'src/app/shared/animations/allAnimations';
import { GenerateSurveyLinkService } from '@ex/ai-readiness/surveys';
import { LandingForm } from '@ex/module/shared/questionnaire/shared-landing/shared-landing.component';
import { LandingParamsResponse, SecureLandingService } from '@ex/module/core/services/secure-landing.service';
import { products } from '@ex/module/core/data-models/company-permission';
@Component({
  selector: 'app-ai-readiness-landing-page',
  templateUrl: './ai-readiness-landing-page.component.html',
  styleUrls: ['./ai-readiness-landing-page.component.scss'],
  animations: [fadeUpDown, ChildrenAnimation],
  providers: [SecureLandingService],
})
export class AiReadinessLandingPageComponent implements OnInit {
  referenceKey: string;
  secureLandingRequest$: Observable<LandingParamsResponse>;
  loader: boolean;
  valid: boolean;
  secureLandingFailed: boolean;

  constructor(private route: ActivatedRoute,
    private secureLandingService: SecureLandingService,
    private generateSurveyLinkService: GenerateSurveyLinkService,
    private router: Router, private zenSnackBarService: ZenSnackbarService) {
  }




  ngOnInit(): void {
    this.referenceKey = this.route.snapshot.paramMap.get('refKey');
    localStorage.setItem('LandingKey', this.referenceKey);

    this.secureLandingRequest$ = this.secureLandingService.specialLandingParams(this.referenceKey, products.AiReadiness);
  }



  onSubmit(event: { params: LandingParamsResponse, form: LandingForm, language: string }) {
    this.generateSurveyLinkService.createSurveyRespondent(this.referenceKey, {
      employeeId: event.form.id,
      email: event.form.email,
      name: event.form.name
    }).pipe(take(1)).subscribe({
      next: (response: any) => {
        if (response.url) {
          this.router.navigate(['/aireadiness-questionnaire/' + response.token]);
          this.loader = false;
        }
      },
      error: (error) => {
        this.zenSnackBarService.error(error.error.error.message);
        this.loader = false;
      }
    })
  }

}
